<section class="webapp-hero">
  <div class="container">
    <div class="hero-content">
      <!-- LEFT TEXT SECTION -->
      <div class="hero-text">
        <img src="https://voyjaleas-website.sebtec12.workers.dev/LOGO_NOFONDO_WHITE.png" alt="Voy Jaleas Logo" class="logo-banner" />
        <!-- <h5 class="subtitle">TRAVEL COMMUNITY & SERVICES</h5> -->
        <h1 class="main-title">
          TU PORTAL PARA<br><span>LLEGAR A ESPAÑA</span>
        </h1>
        <p class="description">
          Explorá nuestras apps exclusivas para contratar seguros, preparar tu visado, y avanzar paso a paso hacia tu nueva vida en España.
        </p>
        <a href="https://app.voyjaleas.com/#/home" class="cta-button">Guías y servicios online</a>
      </div>

      <!-- RIGHT IMAGE / PHONE MOCKUP -->
      <div class="hero-image">
        <div class="phone-wrapper">
          <img src="https://voyjaleas-website.sebtec12.workers.dev/webapp-apps.png" alt="WebApp Screenshot" class="phone-image" />

          <div class="badge access">
            <span>⬇️ Accede sin descargar</span>
          </div>
          <div class="badge ai">
            <span>🤖 Powered by <strong>AI</strong></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
  